import { Link } from "react-router-dom";
import { useTranslation } from "@/i18n/LanguageContext";
import { InstagramGlyph, TelegramGlyph } from "@/components/vangard/SocialGlyphs";

/**
 * Brochure-style footer with brand and legal links.
 */
export default function VangardFooter() {
  const { t } = useTranslation();
  return (
    <footer
      className="relative border-t border-white/[0.06] mt-24"
      data-testid="vangard-footer"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12 grid grid-cols-1 md:grid-cols-3 gap-10 items-start">
        <div>
          <div className="flex items-center gap-2.5">
            <img src="/logo-light.png" alt="" className="h-8 w-auto" aria-hidden="true" draggable={false} />
            <div className="font-serif text-2xl text-white">Vangard<span className="text-neutral-400">Club</span></div>
          </div>
          <p className="text-[13px] text-neutral-500 mt-3 max-w-xs leading-relaxed">
            {t("vc.footer.tagline")}
          </p>

          <div className="mt-6 flex items-center gap-5" data-testid="footer-socials">
            <a
              href="https://www.instagram.com/vangardclub_official"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              title="Instagram"
              data-testid="footer-social-instagram"
              className="inline-flex hover:-translate-y-0.5 hover:opacity-80 transition-all duration-300"
            >
              <InstagramGlyph size={34} />
            </a>
            <a
              href="https://t.me/vangard_public"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Telegram"
              title="Telegram"
              data-testid="footer-social-telegram"
              className="inline-flex hover:-translate-y-0.5 hover:opacity-80 transition-all duration-300"
            >
              <TelegramGlyph size={34} />
            </a>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-6 text-[12px] tracking-[0.15em] uppercase">
          <div className="space-y-3 text-neutral-400">
            <Link to="/about" className="block hover:text-white transition-colors">{t("vc.nav.about")}</Link>
            <Link to="/membership" className="block hover:text-white transition-colors">{t("vc.nav.membership")}</Link>
            <Link to="/magazine" className="block hover:text-white transition-colors">{t("vc.nav.magazine")}</Link>
            <Link to="/concierge" className="block hover:text-white transition-colors">{t("vc.nav.concierge")}</Link>
          </div>
          <div className="space-y-3 text-neutral-400">
            <Link to="/login" className="block hover:text-white transition-colors">{t("vc.nav.signin")}</Link>
            <Link to="/register" className="block hover:text-white transition-colors">{t("vc.nav.join")}</Link>
            <Link to="/privacy" className="block hover:text-white transition-colors">{t("menu.privacy")}</Link>
            <Link to="/terms" className="block hover:text-white transition-colors">{t("menu.terms")}</Link>
          </div>
        </div>

        <div className="md:text-right">
          <div className="text-[11px] tracking-[0.3em] uppercase text-neutral-500">
            {t("vc.footer.stamp")}
          </div>

          <div className="text-[11px] tracking-[0.3em] uppercase text-neutral-600 mt-6">
            © {new Date().getFullYear()} VANGARDCLUB.COM
          </div>
        </div>
      </div>
    </footer>
  );
}
